import axios from "../../config/axiosConfig";
import { CREATE_DESIGN, GET_DESIGN, DESIGN_REQUEST, DELETE_DESIGN, UPDATE_DESIGN, DESIGN_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getDesigns = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DESIGN_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/design/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DESIGN, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createDesign = (design) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DESIGN_REQUEST });

      return axios.post("/design/add", design,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
          if (response.data) {
            dispatch({ type: CREATE_DESIGN, payload: response.data });
            dispatch(addMasterInOption('designs', response.data));
          } else {
            dispatch({
              type: DESIGN_REQUEST_FAILURE,
              error: "Design create failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });
          throw error; 
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDesign = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DESIGN_REQUEST });
      const { auth } = getState();
      return axios.put("/design/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DESIGN,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('designs', id, response.data));
        } else {
          dispatch({
            type: DESIGN_REQUEST_FAILURE,
            error: "Design update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDesign = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DESIGN_REQUEST });
      return axios.delete(`/design/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DESIGN, id: id });
          dispatch(updateMasterInOption('designs', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DESIGN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
